import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMenu = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={24} height={24} fill='none' {...props}>
    <path
      fill='#323E54'
      stroke='#323E54'
      d='M7.5 5.992c0 .824-.676 1.5-1.5 1.5s-1.5-.676-1.5-1.5.676-1.5 1.5-1.5 1.5.676 1.5 1.5Zm6 12c0 .824-.676 1.5-1.5 1.5s-1.5-.676-1.5-1.5.676-1.5 1.5-1.5 1.5.676 1.5 1.5Zm-6 0c0 .824-.676 1.5-1.5 1.5s-1.5-.676-1.5-1.5.676-1.5 1.5-1.5 1.5.676 1.5 1.5Zm0-6c0 .824-.676 1.5-1.5 1.5s-1.5-.676-1.5-1.5.676-1.5 1.5-1.5 1.5.676 1.5 1.5Zm6 0c0 .824-.676 1.5-1.5 1.5s-1.5-.676-1.5-1.5.676-1.5 1.5-1.5 1.5.676 1.5 1.5Zm4.5-4.5c-.824 0-1.5-.676-1.5-1.5s.676-1.5 1.5-1.5 1.5.676 1.5 1.5-.676 1.5-1.5 1.5Zm-4.5-1.5c0 .824-.676 1.5-1.5 1.5s-1.5-.676-1.5-1.5.676-1.5 1.5-1.5 1.5.676 1.5 1.5Zm6 6c0 .824-.676 1.5-1.5 1.5s-1.5-.676-1.5-1.5.676-1.5 1.5-1.5 1.5.676 1.5 1.5Zm0 6c0 .824-.676 1.5-1.5 1.5s-1.5-.676-1.5-1.5.676-1.5 1.5-1.5 1.5.676 1.5 1.5Z'
    />
  </svg>
);
export default SvgMenu;
